import React from "react";

import BackgroundWave from "../Vectors/img/empty-list.png";

const EmptyListState = () => {
  
  return (
    <React.Fragment>
      <img src={BackgroundWave} alt="empty-list" />
    </React.Fragment>
  );
};

export default EmptyListState;
